var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watch"},[(_vm.loading)?_c('div',[_vm._v("\n    Loading video...\n  ")]):(_vm.video)?_c('div',{staticStyle:{"height":"100vh"}},[_c('Video',{ref:"video",attrs:{"url":_vm.video.url,"title":_vm.getVideoTitle},on:{"onBack":_vm.back,"onEnd":_vm.back,"next":_vm.next}})],1):_c('div',[_vm._v("\n    Video not found\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ba6da4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Watch.vue
// module id = null
// module chunks = 